import { apiClient } from "../../src/utils/apiClient";
import { log } from "../../src/utils/log";
import type { MsofficeApiClient } from "../msoffice/api/types";

interface TrackTelemetryParams {
  name: string;
  extra?: object;
}

let registeredApiClient: MsofficeApiClient | null = null;

export function registerTelemetryApiClient(client: MsofficeApiClient) {
  registeredApiClient = client;
}

/**
 * Track a telemetry event via the Dobby backend.
 * The backend handles logging to PostgreSQL, Mixpanel, and New Relic.
 * This is a fire-and-forget operation - errors are logged but not thrown.
 */
export function trackTelemetryFromDobbyBackend(params: TrackTelemetryParams): void {
  // Fire and forget - don't await
  const client = registeredApiClient || apiClient;
  client
    .post<{ success: boolean; id?: string }>("/telemetry/log", params)
    .then((response) => {
      log.debug(`[telemetry] Event logged: ${params.name}`, response.id);
    })
    .catch((error) => {
      // Silently log errors - telemetry should never break the app
      log.debug(`[telemetry] Failed to log event: ${params.name}`, error);
    });
}
